"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDixa = exports.getDixa = void 0;
const tslib_1 = require("tslib");
const sdk_1 = tslib_1.__importDefault(require("./sdk"));
function boot() {
    // skip in case of SSR or when exists already
    if (typeof window === 'undefined' || window._dixa_) {
        return;
    }
    window._dixa_ = {
        invoke(method, arg) {
            window._dixa_.pendingCalls = window._dixa_.pendingCalls || [];
            window._dixa_.pendingCalls.push([method, arg]);
        },
        addListener(event, listener) {
            window._dixa_.pendingAddListenerCalls =
                window._dixa_.pendingAddListenerCalls || [];
            window._dixa_.pendingAddListenerCalls.push([event, listener]);
        },
    };
}
function access() {
    boot();
    return sdk_1.default;
}
function getDixa() {
    return access();
}
exports.getDixa = getDixa;
function useDixa() {
    return access();
}
exports.useDixa = useDixa;
//# sourceMappingURL=access.js.map